(() => {
  const selector = 'product-info[data-velomint-authorization="required"]';

  function lockProduct(root) {
    if (!root) return;

    root.querySelectorAll('form[action*="/cart/add"], product-form').forEach((form) => {
      form.setAttribute('data-velomint-blocked', 'true');
    });

    root.querySelectorAll('button[name="add"], .shopify-payment-button button, [data-testid*="Checkout-button"]').forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('data-velomint-blocked', 'true');
      button.style.display = 'none';
    });
  }

  function lockAll() {
    document.querySelectorAll(selector).forEach(lockProduct);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const root = form.closest(selector);
    if (!root) return;
    if ((form.getAttribute('action') || '').includes('/cart/add') || form.querySelector('[name="add"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      lockProduct(root);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('button[name="add"], .shopify-payment-button button') : null;
    if (!target || !target.closest(selector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    lockProduct(target.closest(selector));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockAll, { once: true });
  } else {
    lockAll();
  }

  new MutationObserver(lockAll).observe(document.documentElement, { childList: true, subtree: true });
})();
